export default __webpack_public_path__ + "static/media/plus.b3ac1ce6.svg";